import { Place } from '@app/entities/place';
import { Airport } from '@app/modules/core/interfaces/airport';

export interface SearchInputPayload {
  places: Place[];
  airports: Airport[];
}

export interface ChangeInputPayload {
  value: string;
  isEmpty: boolean;
}

export enum AutocompleteType {
  Cities = 'cities',
  Airports = 'airports',
  Activities = 'activities',
  Destinations = 'destinations',
}
